<template>
	<div class="output">
		<h2>Configuration string</h2>

		<div class="string">
			<div class="overflow-cheat">
				<span v-show="match">m{{match}}</span>
				<template v-for="(team, index) in teams">
					<span v-if="index == 0">t{{team}}</span>
					<span v-else>&nbsp;t{{team}}</span>
				</template>
				<template v-for="(player, index) in players">
					<span v-if="index == 0">p{{player}}</span>
					<span v-else>&nbsp;p{{player}}</span>
				</template>
		    </div>
	    </div>

		<transition name="slide-fade">
	    	<div class="copy-success" v-if="copied" v-bind:key="1">Copied to clipboard</div>
	    </transition>

	    <button @click="copy" class="copy">Copy to clipboard</button>
	</div>
</template>

<script>
	export default {
		name: 'Meta',
		data () {
			return {
				copied: false
			}
		},
		props: ['match', 'teams', 'players'],
		methods: {
			copy: function() {
				let self = this;
				let elem = document.querySelectorAll('.overflow-cheat');
				let string = elem[0].innerText;
				let textarea =document.createElement('textarea');

				textarea.textContent = string;
				textarea.style.position = 'fixed';
				document.body.appendChild(textarea);

				textarea.select();
				try {
					return document.execCommand("copy"); 
				} catch (ex) {
					alert("Copy to clipboard failed.", ex);
					return false;
				} finally {
					document.body.removeChild(textarea);
					self.showCopyMessage();
					console.info('Copied successfully.')
				}
			},
			showCopyMessage: function() {
				let self = this;
				this.copied = true;

				setTimeout(function(){
					self.copied = false;
				}, 2000);
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.output {
		font-size: 30px;		
		max-width: 1180px;
		margin: 0 auto;
		text-align: left;
		background-color: darken(#fafafa, 0%);
	    border-radius: 4px;
	    padding: 30px;
	    margin-bottom: 20px;
	    margin-top: 40px;
	}

	.string {
		white-space: nowrap;
		overflow: hidden;
		max-width: 100%;
		height: 50px;
		font-size: 30px;
		line-height: 30px;
		background-color: rgba(0,0,0,0.05);
		border-radius: 4px;
		padding: 12px 20px;
		margin-top: -10px;
		margin-bottom: 20px;
	}

	h2 {
		font-size: 40px;
		text-align: left;
	}

	.copy {
		font-size: 30px;
		background-color: #49D49D;
		color: #fff;
		padding: 8px 15px;
		border: none;
		border-radius: 4px;
		margin: 0 auto;
		display: inline-block;
		margin-top:20px;
		text-transform: uppercase;

		&:focus {
			outline: none;
		}
	}

	.overflow-cheat {
		padding-bottom: 50px;
		text-align: left;
		overflow: auto;
	}

	.copy-success {
		position: fixed;
		top: 50%;
		left: 50%;
		background-color: rgba(0,0,0,0.6);
		color:#fff;
		transform: translate(-50%, -50%);
		margin-top: 0;
		padding: 8px 15px;
		text-transform: uppercase;
		font-size: 16px;
		border-radius: 6px;
	}

	.slide-fade-enter-active {
		transition: all .8s ease;
	}
	.slide-fade-leave-active {
		transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter, .slide-fade-leave-to {
		opacity: 0;
		margin-top: -30px;
	}

</style>



// WEBPACK FOOTER //
// Meta.vue?14edf0a0